// Angular modules.
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'nl2br' })
export class Nl2brPipe implements PipeTransform {
	constructor() {}
	transform(value: string): string {
		return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '<br/>');
	}
}
